(() => {
  if (window.__themumeDeliveryTimelineLoaded) return;
  window.__themumeDeliveryTimelineLoaded = true;

  const locale = document.documentElement.lang || 'en-US';
  const dateFormat = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });

  const offset = (start, days) => new Date(start.getFullYear(), start.getMonth(), start.getDate() + days, 12);
  const format = (start, days) => dateFormat.format(offset(start, days));
  const number = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
  };

  function updateTimelines() {
    const today = new Date();
    document.querySelectorAll('.tm-delivery-timeline').forEach((timeline) => {
      const shipMin = number(timeline.dataset.shipMin, 1);
      const shipMax = Math.max(shipMin, number(timeline.dataset.shipMax, 2));
      const deliveryMin = number(timeline.dataset.deliveryMin, 7);
      const deliveryMax = Math.max(deliveryMin, number(timeline.dataset.deliveryMax, 12));
      const dates = {
        ordered: format(today, 0),
        shipped: `${format(today, shipMin)} – ${format(today, shipMax)}`,
        delivered: `${format(today, deliveryMin)} – ${format(today, deliveryMax)}`,
      };
      Object.entries(dates).forEach(([stage, value]) => {
        const target = timeline.querySelector(`[data-tm-date="${stage}"]`);
        if (target) target.textContent = value;
      });
    });
  }

  function scheduleMidnightUpdate() {
    const now = new Date();
    const nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1);
    window.setTimeout(() => {
      updateTimelines();
      scheduleMidnightUpdate();
    }, Math.max(1000, nextMidnight.getTime() - now.getTime()));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTimelines, { once: true });
  } else {
    updateTimelines();
  }
  document.addEventListener('shopify:section:load', updateTimelines);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateTimelines();
  });
  scheduleMidnightUpdate();
})();
